module.exports = __webpack_public_path__ + "static/media/IconTemplates_-03.3c80e063.svg";